const globalRTLStyles = {
  '.closeButton': {
    right: 'auto !important',
    left: '10px',
  },
  '.conversationMenubutton': {
    left: 'auto !important',
    right: '8px',
  },
  '.backButton': {
    transform: 'rotate(180deg)',
  },
  '.minimizedUnreadIcon': {
    left: 'auto !important',
    right: '32px',
  },
  '.kustomer-app-icon': {
    right: 'auto !important',
    left: '25px',
  },
  '.chatAppWrapper': {
    left: '25px',
    right: 'auto !important',
  },
};

export default globalRTLStyles;
